import { render, staticRenderFns } from "./Tracking.vue?vue&type=template&id=a87a4008"
import script from "./Tracking.vue?vue&type=script&lang=js"
export * from "./Tracking.vue?vue&type=script&lang=js"
import style0 from "./Tracking.vue?vue&type=style&index=0&id=a87a4008&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports